import { z } from "zod";

export const emailArraySchema = z.array(z.string().email()).transform((emails) => [...new Set(emails)]);
export type EmailArray = z.infer<typeof emailArraySchema>;